import { useEntity } from '@backstage/plugin-catalog-react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import useAsync from 'react-use/esm/useAsync';
import { codeCoverageApiRef } from '../../api.esm.js';
import { CodeRow } from './CodeRow.esm.js';
import { highlightLines } from './Highlighter.esm.js';
import { Progress, ResponseErrorPanel } from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "auto",
    top: "2em",
    width: "80%",
    border: `2px solid ${theme.palette.common.black}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll"
  },
  coverageFileViewTable: {
    borderSpacing: "0px",
    width: "80%",
    marginTop: theme.spacing(2)
  }
}));
const FormattedLines = ({
  highlightedLines,
  lineHits
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, highlightedLines.map((lineContent, idx) => {
    const line = idx + 1;
    return /* @__PURE__ */ React.createElement(
      CodeRow,
      {
        key: line,
        lineNumber: line,
        lineContent,
        lineHits: lineHits[line]
      }
    );
  }));
};
const FileContent = ({ filename, coverage }) => {
  const { entity } = useEntity();
  const codeCoverageApi = useApi(codeCoverageApiRef);
  const { loading, error, value } = useAsync(
    async () => await codeCoverageApi.getFileContentFromEntity(
      {
        kind: entity.kind,
        namespace: entity.metadata.namespace || "default",
        name: entity.metadata.name
      },
      filename
    ),
    [entity]
  );
  const classes = useStyles();
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  }
  if (error) {
    return /* @__PURE__ */ React.createElement(ResponseErrorPanel, { error });
  }
  if (!value) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "warning" }, "Unable to retrieve file content for ", filename);
  }
  const [language] = filename.split(".").slice(-1);
  const highlightedLines = highlightLines(language, value.split("\n"));
  const lineHits = Object.entries(coverage.lineHits).reduce(
    (acc, next) => {
      acc[next[0]] = next[1];
      return acc;
    },
    {}
  );
  return /* @__PURE__ */ React.createElement(Paper, { variant: "outlined", className: classes.paper }, /* @__PURE__ */ React.createElement("table", { className: classes.coverageFileViewTable }, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(
    FormattedLines,
    {
      highlightedLines,
      lineHits
    }
  ))));
};

export { FileContent };
//# sourceMappingURL=FileContent.esm.js.map
